import client from "./client";

export const myDeletionRequest = async () => (await client.get("/account/deletion-request")).data;
export const requestAccountDeletion = async (reason) =>
  (await client.post("/account/deletion-request", { reason })).data;
export const requestDeleteCode = async () => (await client.post("/account/delete/request-code")).data;
export const deleteMyAccountNow = async (reason, code) =>
  (await client.post("/account/delete", { reason, code })).data;
export const listDeletionRequests = async (status = "pending") =>
  (await client.get("/account/deletion-requests", { params: { status } })).data;
export const decideDeletionRequest = async (id, action) =>
  (await client.post(`/account/deletion-requests/${id}/${action}`)).data;
